import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { NavItemRoot, NavItemSub } from './NavItem';
import { getActive } from '..';

/* ============================================================================
   Grupo do menu lateral - visual novo.

   Sem `Collapse` do MUI: a abertura e uma grade com `grid-rows-[0fr]` ->
   `grid-rows-[1fr]`, que anima a altura real sem precisar medi-la em JS.

   DEFEITO CORRIGIDO: `useState(active)` calcula o estado inicial UMA vez, na
   montagem. A sidebar nao desmonta ao navegar, entao entrar numa rota filha por
   link direto (ex.: clicar em "Feriados" a partir de uma notificacao) deixava o
   pai FECHADO, escondendo o item que estava aberto na tela. O `useEffect` abaixo
   abre o pai quando a rota passa a casar com ele.

   O que NAO faz: fechar sozinho quando sai da rota. Fechar submenu debaixo do
   cursor de quem esta navegando pelo menu e pior que deixar aberto.
   ============================================================================ */

export function NavListRoot({ list, isCollapse }) {
  const { pathname, asPath } = useRouter();

  const active = getActive(list.path, pathname, asPath);
  const temFilhoAtivo = (list.children || []).some((f) => getActive(f.path, pathname, asPath));

  const [open, setOpen] = useState(active || temFilhoAtivo);

  useEffect(() => {
    if (active || temFilhoAtivo) setOpen(true);
  }, [active, temFilhoAtivo]);

  if (list.children) {
    return (
      <div>
        <NavItemRoot
          item={list}
          isCollapse={isCollapse}
          active={active || temFilhoAtivo}
          open={open}
          onOpen={() => setOpen(!open)}
        />

        {/* Colapsada, a sidebar nao mostra submenu: nao ha largura para o rotulo,
            e ponto sem texto nao identifica nada. */}
        {!isCollapse && (
          <div
            className={`grid transition-[grid-template-rows] duration-200 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
          >
            <div className="overflow-hidden">
              <div className="ml-3 space-y-0.5 border-l border-line pl-1.5 pt-0.5">
                {(list.children || []).map((item) => (
                  <NavListSub key={item.title} list={item} />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} />;
}

// ----------------------------------------------------------------------

function NavListSub({ list }) {
  const { pathname, asPath } = useRouter();

  const active = getActive(list.path, pathname, asPath);
  const temFilhoAtivo = (list.children || []).some((f) => getActive(f.path, pathname, asPath));

  const [open, setOpen] = useState(active || temFilhoAtivo);

  useEffect(() => {
    if (active || temFilhoAtivo) setOpen(true);
  }, [active, temFilhoAtivo]);

  if (list.children) {
    return (
      <div>
        <NavItemSub item={list} onOpen={() => setOpen(!open)} open={open} active={active || temFilhoAtivo} />

        <div
          className={`grid transition-[grid-template-rows] duration-200 ${open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
        >
          <div className="overflow-hidden">
            <div className="ml-3 space-y-0.5 border-l border-line pl-1.5">
              {(list.children || []).map((item) => (
                <NavItemSub key={item.title} item={item} active={getActive(item.path, pathname, asPath)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <NavItemSub item={list} active={active} />;
}
